import { render, staticRenderFns } from "./AddAttachmentTypesPage.vue?vue&type=template&id=301af0d9&"
import script from "./AddAttachmentTypesPage.vue?vue&type=script&lang=js&"
export * from "./AddAttachmentTypesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports